// extracted by mini-css-extract-plugin
export var externalLink = "_ca-0";
export var internalLinkLabel = "_ca-1";